import eventBus from '../../js/event-bus';
import $ from '../../js/i18n.config';

const buttonCol = {
  type: 'buttons',
  buttons: [
    {
      name: 'editCargos',
      icon: 'edit',
      hint: $.t('common.toolTips.edit'),
    },
    {
      name: 'deleteCargos',
      icon: 'trash',
      hint: $.t('common.toolTips.delete'),
    },
  ],
};

export const colMethods = {
  openCargosPopup(e) {
    eventBus.$emit('showCargosPopup', e.row.data);
    eventBus.$emit('setMarkerPosition', e.row.data);
  },
  async removeCargos(e) {
    await this.removeMerchandise(e.row.data.id);
  },
  addButtonFuncs(buttons) {
    buttons.forEach((button) => {
      switch (button.name) {
        case 'editCargos':
          button.onClick = this.openCargosPopup;
          break;
        case 'deleteCargos':
          button.onClick = this.removeCargos;
          break;
        default:
          break;
      }
    });
  },
};
export default [
  {
    dataField: 'name',
    caption: $.t('common.blocks.cargo'),
    dataType: 'string',
  },
  {
    dataField: 'category',
    caption: $.t('administration.cargo.category'),
    dataType: 'string',
  },
  buttonCol,
];
